export const fakeAccount = {
    name: "Dev User",
    username: "dev@local.test",
    clientID: "123",
    associateState: "ACTIVE"
};
